import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "system",
  "use": "system-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"system\"><g fill-rule=\"nonzero\"><path d=\"M0 3h4v11H0zM6 0h4v14H6zM12 8h4v6h-4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id